export const imports = {
  'src/pages/options.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-pages-options" */ 'src/pages/options.mdx'
    ),
  'src/pages/GettingStarted/curve.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-pages-getting-started-curve" */ 'src/pages/GettingStarted/curve.mdx'
    ),
  'src/pages/GettingStarted/intro.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-pages-getting-started-intro" */ 'src/pages/GettingStarted/intro.mdx'
    ),
  'src/pages/Player/player.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-pages-player-player" */ 'src/pages/Player/player.mdx'
    ),
  'src/pages/Travel/tavel.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-pages-travel-tavel" */ 'src/pages/Travel/tavel.mdx'
    ),
  'src/pages/api/useFade.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-pages-api-use-fade" */ 'src/pages/api/useFade.mdx'
    ),
  'src/pages/api/useMorphKeys.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-pages-api-use-morph-keys" */ 'src/pages/api/useMorphKeys.mdx'
    ),
  'src/pages/api/useMorphList.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-pages-api-use-morph-list" */ 'src/pages/api/useMorphList.mdx'
    ),
  'src/pages/demos/docs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-pages-demos-docs" */ 'src/pages/demos/docs.mdx'
    ),
  'src/pages/styling/styling.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "src-pages-styling-styling" */ 'src/pages/styling/styling.mdx'
    ),
}
